<template>
  <div class="slide">
    <div class="slide__image">
      <img :src="getImgUrl(item.featured)" alt="Slide Alt">
    </div>
    <a class="slide__footer" @click="$router.push({name: 'Project', params: {slug: item.slug}})">
      <h2 class="slide__title" v-text="item.title"></h2>
      <h5 class="slide__category" v-text="item.category"></h5>
    </a>
  </div>
</template>

<script>
export default {
  name: 'Slide',
  props: {
    item: {
      type: Object,
      required: true
    }
  },
  methods: {
    getImgUrl (img) {
      var images = require.context('@/assets/', false, /\.jpg$/)
      return images('./' + img + '.jpg')
    }
  }
}
</script>

<style lang="scss">

.slide {
  position: relative;
  display: grid;
  grid-template-rows: 70% 30%;
  grid-row-gap: 2rem;
  width: 100%;
  height: 100%;
}

.slide__footer {
  cursor: pointer;
}

.slide__image {
  img {
    display: block;
    width: 100%;
    height: 100%;
    -o-object-fit: cover;
    object-fit: cover;
    pointer-events: none;
    -webkit-user-drag: none;
    -khtml-user-drag: none;
    -moz-user-drag: none;
    -o-user-drag: none;
    // user-drag: none;
  }
}

.slide__title {
  font-size: 2rem;
  line-height: 1;
  margin-bottom: 0;

  @media screen and (min-width: 640px) {
      margin-bottom: .5rem;
      font-size: 3rem;
  }
}

.slide__category {
  margin: 0;
  color: #797979;
}
</style>
